module.exports = __webpack_public_path__ + "static/img/section4_content1_Bg1.b528c3c5.png";